// extracted by mini-css-extract-plugin
export default {"pureCell":"phone-info_pureCell__v6dJg"};